<template>
    <div id="legal-view">
        <Hero />
        <div class="switch wrapper">
            <ToggleSwitch :from="firstLegalMarkdown" :to="secondLegalMarkdown" @update:selectedId="onIdChange" />
        </div>
        <div class="legal-content wrapper">
            <LegalMarkdownLoader />
        </div>

        <Banner />
        <ContactBanner />
    </div>
</template>
<script setup>
import { getLegalCollection } from '@/assets/markdowns/legal/LegalCollection';
import Hero from '@/components/Hero.vue';
import Banner from '@/components/banner/Banner.vue';
import ContactBanner from '@/components/banner/ContactBanner.vue'
import LegalMarkdownLoader from '@/components/shared/LegalMarkdownLoader.vue';
import ToggleSwitch from '@/components/ui/toggle-switch.vue';
import { onMounted, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';

const route = useRoute();
const router = useRouter();
const { locale } = useI18n();
const legalMds = getLegalCollection(locale.value) || [];
const firstLegalMarkdown = ref({ title: legalMds?.[0].title || '', id: legalMds?.[0].slug || '', active: false });
const secondLegalMarkdown = ref({ title: legalMds?.[1].title || '', id: legalMds?.[1].slug || '', active: false });

function loadMarkdowns() {
    const mds = getLegalCollection(locale.value) || [];
    legalMds.value = mds;

    if (mds.length >= 2) {
        firstLegalMarkdown.value = {
            title: mds[0].title,
            id: mds[0].slug,
            active: route.params.id === mds[0].slug,
        };
        secondLegalMarkdown.value = {
            title: mds[1].title,
            id: mds[1].slug,
            active: route.params.id === mds[1].slug,
        };
    }
}

function setCurrentMarkdown() {
    const id = route.params.id;
    if (!id || legalMds.value.length < 2) return;

    firstLegalMarkdown.value.active = firstLegalMarkdown.value.id === id;
    secondLegalMarkdown.value.active = secondLegalMarkdown.value.id === id;
}

function onIdChange(newId) {
    if (route.params.id === newId) return;
    router.push({ name: 'legal', params: { id: newId } });
}

onMounted(() => {
    loadMarkdowns();
    setCurrentMarkdown();
});

watch(locale,
    () => {
        loadMarkdowns();
        setCurrentMarkdown();
    }
);

watch(
    () => route.params.id,
    () => {
        setCurrentMarkdown();
    }
);

</script>
<style scoped>
#legal-view {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 4rem;
    padding: var(--SectionPadding);
}

.switch {
    display: flex;
    justify-content: center;

}

.legal-content {
    margin-top: -2rem;
}
</style>